module.exports = __webpack_public_path__ + "static/media/wallet_icon.967e09d9.svg";